export const TESTFLIGHT_URL = 'https://testflight.apple.com/join/X1uaaAVz';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.poptheballoon';

export type Platform = 'ios' | 'android' | 'desktop';
export type Store = 'google_play' | 'ios_beta';
// Where on the page a store link was tapped
export type Placement = 'hero' | 'sticky' | 'bottom' | 'header' | 'page';

// The desktop QR code opens the homepage with ?utm_source=qr
const cameFromQr = new URLSearchParams(window.location.search).get('utm_source') === 'qr';

// First part of the path, so /blog/some-post counts as blog
const pageName = () => window.location.pathname.split('/')[1] || 'homepage';

// The UTM referrer lets Play Console (Store listing acquisition) count installs from the website,
// split by page (utm_medium) and where the link was tapped (utm_campaign)
export const playStoreUrl = (placement: Placement) => {
    const campaign = cameFromQr ? `qr_${placement}` : placement;
    const referrer = `utm_source=website&utm_medium=${pageName()}&utm_campaign=${campaign}`;
    return `${PLAY_STORE_URL}&referrer=${encodeURIComponent(referrer)}`;
};

// Consent mode starts with analytics denied and the site never asks, so GA mostly receives
// cookieless pings. Play Console's UTM report is the install number to trust.
export const trackStoreClick = (store: Store, placement: Placement, platform: Platform) => {
    window.gtag?.('event', 'app_store_click', { store, placement, platform, page: pageName(), from_qr: cameFromQr });
};

/** The visitor's own store: the TestFlight beta on iPhone, Google Play everywhere else. */
export const downloadLinkFor = (platform: Platform, placement: Placement) =>
    platform === 'ios'
        ? { href: TESTFLIGHT_URL, store: 'ios_beta' as Store, label: 'Join the iOS beta' }
        : { href: playStoreUrl(placement), store: 'google_play' as Store, label: 'Get it on Google Play' };
